import { QueryKey } from 'constants/reactQuery';
import { InboxNotiType } from '@diritto/common/notification/constants';

export const notiQueryKey = {
  inboxNoti: [QueryKey.InboxNoti] as const,
  inboxNotiList: (inboxNotiType: InboxNotiType) => [QueryKey.InboxNoti, inboxNotiType] as const,
  read: [QueryKey.InboxNoti, 'read'] as const,
  unreadCount: () => [QueryKey.InboxNotiUnreadCount] as const,
  profileUnreadCount: () => [QueryKey.InboxNotiUnreadCount, QueryKey.Profile] as const,
};
